import React from 'react';
import styles from './SiteHeader.module.css';

export default function SiteHeader() {
  return (
    <header className={styles.header}>
      <a className={styles.brand} href="/">
        Sergio Peterson
      </a>
      <nav className={styles.navigation} aria-label="Primary navigation">
        <a href="/blog/">Blog</a>
      </nav>
    </header>
  );
}
